import { ApaduaAPI } from './ApaduaAPI';

export class TenantsAPI extends ApaduaAPI {
    resource: string = 'api/tenants/';

    getTenants(): Promise<Array<any>> {
        return this.get('') as any;
    }
}
